var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeployFileBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "88px",
    height: "88px",
    viewBox: "0 0 88 88",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(15.000000, 8.000000)",
    fill: "#333",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.875,0 L7.375,0 C3.30189997,0 0,3.26832133 0,7.3 L0,65.7 C0,69.7316787 3.30189997,73 7.375,73 L51.625,73 C55.6981,73 59,69.7316787 59,65.7 L59,21.9 L36.875,0 M35.03125,51.1 L35.03125,62.05 L23.96875,62.05 L23.96875,51.1 L14.75,51.1 L29.5,36.5 L44.25,51.1 L35.03125,51.1 M33.1875,25.55 L33.1875,5.475 L53.46875,25.55 L33.1875,25.55 Z",
    id: "Icon-Shape"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "ViewBox",
    x: 0,
    y: 0,
    width: 88,
    height: 88
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeployFileBlack);
export default __webpack_public_path__ + "static/media/deploy_file_black.c3399cf4fb388de7520c772187e24896.svg";
export { ForwardRef as ReactComponent };